import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

function NewImageContainer(props) {
  const {
    handleSave,
    image,
    imageName,
    imageFileExt,
    setImage,
    setImageName,
    setImageFilename,
  } = props;

  const handleImageNameChange = (e) => {
    e.preventDefault();
    setImageName(e.target.value);
  };

  const handleUnselectImage = (e) => {
    e.preventDefault();
    setImage(null);
    setImageFilename('');
  };

  return (
    <Card
      raised
      sx={{
        borderStyle: 'solid',
        borderColor: (theme) => theme.palette.error.main,
      }}>
      <CardHeader
        titleTypographyProps={{ align: 'left' }}
        title={
          <TextField
            id='dropped-image-name'
            variant='standard'
            sx={{ width: '90%' }}
            onChange={handleImageNameChange}
            value={imageName}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>{imageFileExt}</InputAdornment>
              ),
            }}
          />
        }
        action={
          <Stack
            direction='row'
            spacing={2}
            justifyContent='flex-start'
            alignItems='center'
            mr={2}
            sx={{ width: '100%', mt: '2px' }}>
            <Button
              color='primary'
              variant='contained'
              size='small'
              onClick={handleSave}
              sx={{ height: '2rem' }}>
              Save
            </Button>
            <IconButton
              onClick={handleUnselectImage}
              sx={{ height: 33, width: 33 }}>
              <FontAwesomeIcon icon={['fal', 'times']} />
            </IconButton>
          </Stack>
        }
      />
      <CardMedia component='img' image={image} alt={imageName} />
    </Card>
  );
}

NewImageContainer.propTypes = {
  image: PropTypes.string,
  imageName: PropTypes.string.isRequired,
  imageFileExt: PropTypes.string.isRequired,
  setImage: PropTypes.func.isRequired,
  setImageName: PropTypes.func.isRequired,
  setImageFilename: PropTypes.func.isRequired,
};

export default NewImageContainer;
